module.exports = __webpack_public_path__ + "static/icons/icon-chevron-left-e721d8c77dfbe54fb342af3d6928cd6c.svg";